import { useCallback } from "react";
import { Link, useParams } from "react-router";
import { formatShopPrice } from "@shared/shop/price";
import { routes } from "../../app/routes";
import { useResource } from "../../platform/async/useResource";
import { PageShell } from "../../platform/ui/PageShell";
import { PagedReader } from "../../platform/ui/PagedReader";
import { StateMessage } from "../../platform/ui/StateMessage";
import { PostBody } from "../blog";
import { fetchListing } from "./shop-api";
import "../blog/blog.css";
import "./shop.css";

export function ListingPage() {
  const { slug = "" } = useParams();
  const listing = useResource(useCallback((signal) => fetchListing(slug, signal), [slug]));
  if (listing.status !== "ready") {
    const missing = listing.status === "failed" && listing.error.failure === "not_found";
    return (
      <PageShell title="Orla's Shop">
        <StateMessage
          tone={listing.status === "loading" ? "loading" : "error"}
          title={
            listing.status === "loading"
              ? "Fetching the listing"
              : missing
                ? "This listing is not available"
                : "The listing could not be loaded"
          }
          {...(listing.status === "failed" && !missing
            ? { action: { label: "Try again", onSelect: listing.retry } }
            : {})}
        />
        <p>
          <Link to={routes.shop()}>Back to the shop</Link>
        </p>
      </PageShell>
    );
  }
  const item = listing.data;
  return (
    <PageShell
      eyebrow={item.type === "service" ? "A service from Orla" : "A product from Orla"}
      title={item.title}
      lead={item.summary}
      layout="viewport"
    >
      <PagedReader label={item.title}>
        <article className="shop-detail">
          <p className="shop-price">{formatShopPrice(item)}</p>
          <PostBody markdown={item.descriptionMd} />
          <p className="shop-note">
            Enquire to agree the scope, final price and payment arrangements. No payment is taken on
            this website.
          </p>
        </article>
      </PagedReader>
      <div className="shop-actions">
        <Link className="shop-enquire glass" data-glass-interactive to={routes.enquiry(item.slug)}>
          Enquire with Orla
        </Link>
        <Link to={routes.shop()}>All listings</Link>
      </div>
    </PageShell>
  );
}
